import Select from "react-select";
import React, { useState, useRef, useEffect } from "react";
import { SELECT_ALL } from "../Constants";
import { customMultiSelectStyles } from "commons/styles/CustomStyles";

const MultiSelectFilterWithAll = ({
  column,
  handleFilterChange,
  filterValue,
}) => {
  const { id } = column;
  const [open, setOpen] = useState(false);
  const selectRef = useRef(null);
  
  const normalizeValues = (values, options) => {
    return [].concat(values || [])
      .map((val) => {
        if (typeof val === "string") {
          return options.find((opt) => opt?.id === val || opt?.name === val);
        }
        return val;
      })
      .filter((val) => val && options.some((opt) => opt?.id === val.id));
  };

  const normalizedFilterValue = normalizeValues(
    filterValue,
    column.filterOptions
  );

  const handleChange = (selectedOptions, actionMeta) => {
    const { action, option, removedValue } = actionMeta || {};

    // Handle SELECT_ALL special option
    if (action === "select-option" && option?.id === SELECT_ALL) {
      // Select all real options (excluding the SELECT_ALL marker)
      const allOptions = column.filterOptions.filter(
        (opt) => opt?.id !== SELECT_ALL
      );
      handleFilterChange(id, allOptions, column);
      return;
    }

    if (
      (action === "deselect-option" || action === "remove-value") &&
      removedValue?.id === SELECT_ALL
    ) {
      handleFilterChange(id, [], column);
      return;
    }

    const cleaned = (selectedOptions || []).filter(
      (opt) => opt?.id !== SELECT_ALL
    );
    handleFilterChange(id, cleaned, column);
  };

  const handleFocus = () => {
    // Open menu when select receives focus
    setOpen(true);
  };

  const handleBlur = (e) => {
    // Check if focus is moving outside the select component
    const currentTarget = e.currentTarget;
    const relatedTarget = e.relatedTarget;
    
    // If focus is moving to another element (not within the select), close menu
    if (relatedTarget && !currentTarget.contains(relatedTarget)) {
      setOpen(false);
    }
  };

  const handleKeyDown = (e) => {
    // Close menu on Tab key and ensure focus moves to next element
    if (e.key === 'Tab' && open) {
      setOpen(false);
    }
  };

  return (
    <div id={`multiselect${id}`} ref={selectRef}>
      <Select
        isMulti
        closeMenuOnSelect={false}
        options={column.filterOptions}
        value={normalizedFilterValue}
        onChange={handleChange}
        isDisabled={column.isDisabled}
        placeholder=""
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option.id}
        isClearable={false}
        tabSelectsValue={false}
        openMenuOnFocus={false}
        menuIsOpen={open}
        onMenuOpen={() => setOpen(true)}
        onMenuClose={() => setOpen(false)}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        menuPosition="fixed"
        components={{
          DropdownIndicator: () => null, // Removes the dropdown arrow
          IndicatorSeparator: () => null // Optionally removes the vertical line separator
        }}
        styles={{
          ...customMultiSelectStyles,
          menu: (base) => ({
            ...base,
            width: "fit-content",
            background: "white",
            maxHeight: "fit-content",
          }),
        }}
      />
    </div>
  );
};

export default MultiSelectFilterWithAll;